import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './components/login/login.component';
import { LayoutComponent } from './components/layout/layout.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { BookingComponent } from './components/booking/booking.component';
import { UserComponent } from './components/user/user.component';
import { FinanceOverviewComponent } from './components/finance-overview/finance-overview.component';
import { HelpsupportComponent } from './components/helpsupport/helpsupport.component';
import { SettingsComponent } from './components/settings/settings.component';
import { ContenManagerComponent } from './components/conten-manager/conten-manager.component';
import { SubsettingComponent } from './components/subsetting/subsetting.component';
import { PersonaldetailsComponent } from './components/personaldetails/personaldetails.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { PreferenceComponent } from './components/preference/preference.component';
import { SecurityComponent } from './components/security/security.component';
// import { TestingComponent } from './components/testing/testing.component';
import { CancellationReasonsComponent } from './components/cancellation-reasons/cancellation-reasons.component';

import { AuthGuard } from './auth.guard';

const routes: Routes = [
  { path: '', component: LoginComponent },
  {
    path: 'admin',
    component: LayoutComponent,
    canActivateChild: [AuthGuard], 
    children: [
      { path: 'dashboard', component: DashboardComponent },
      // { path: 'test', component: TestingComponent },
      { path: 'booking', component: BookingComponent },
      { path: 'user', component: UserComponent },
      { path: 'finance', component: FinanceOverviewComponent },
      { path: 'helpsupport', component: HelpsupportComponent },
      { path: 'settings', component: SettingsComponent },
      { path: 'contentmanager', component: ContenManagerComponent },
      {
        path: 'subsetting',
        component: SubsettingComponent,
        children: [
          { path: '', redirectTo: 'personaldetails', pathMatch: 'full' },
          { path: 'personaldetails', component: PersonaldetailsComponent },
          { path: 'notification', component: NotificationsComponent },
          { path: 'preference', component: PreferenceComponent },
          { path: 'security', component: SecurityComponent },
          { path: 'cancellation-reasons', component: CancellationReasonsComponent }
        ]
      }
    ]
  },
  { path: '**', redirectTo: '' }
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
